import { call, put, takeLatest } from 'redux-saga/effects';
import * as api from '../../api';
import * as actions from './actions';
import { showToast } from '../../components/toast/actions';

/**
 * GET SECTION FILE
 */
export function* getSectionFile({ sectionId }) {
    const request = { sectionId };
    const downloadUrl = yield call(api.getSectionFile, request);
    window.location.assign(downloadUrl);
}

export function* getSectionFileSaga() {
    yield takeLatest(actions.GET_SECTION_FILE_REQUEST, getSectionFile);
}

/**
 * CHECK SECTION FILE
 */
export function* checkSectionFile({ sectionId }) {
    const request = { sectionId };

    const payload = yield call(api.checkSectionFile, request);
    const fileName = payload.data;

    if (payload.status === 200) {
        yield put(actions.checkSectionFileSuccess(fileName));
    } else {
        yield put(actions.checkSectionFileFailure());
    }
}

export function* checkSectionFileSaga() {
    yield takeLatest(actions.CHECK_SECTION_FILE_REQUEST, checkSectionFile);
}

/**
 * DELETE SECTION FILE
 */
export function* deleteSectionFile({ sectionId }) {
    const request = { sectionId };

    const payload = yield call(api.deleteSectionFile, request);

    if (payload.status === 204) {
        yield put(showToast('Curriculum alignment file deleted successfully', 'success'));
        yield put(actions.deleteSectionFileSuccess());
    } else {
        yield put(showToast('Delete Publication File Failed', 'error'));
        yield put(actions.deleteSectionFileFailure());
    }
}

export function* deleteSectionFileSaga() {
    yield takeLatest(actions.DELETE_SECTION_FILE_REQUEST, deleteSectionFile);
}

/**
 * UPLOAD SECTION FILE
 */
export function* uploadSectionFile({ sectionId, uploadedFile }) {
    const request = {
        sectionId,
        uploadedFile
    };

    const payload = yield call(api.uploadSectionFile, request);

    if (payload.status === 200) {
        yield put(showToast('Curriculum alignment file uploaded successfully', 'success'));
        yield put(actions.checkSectionFile(sectionId));
        yield put(actions.uploadSectionFileSuccess());
    } else {
        yield put(showToast('Upload Failed', 'error'));
    }
}

export function* uploadSectionFileSaga() {
    yield takeLatest(actions.UPLOAD_SECTION_FILE_REQUEST, uploadSectionFile);
}



// WEBPACK FOOTER //
// ./app/containers/curriculum-documents/saga.js